<template>
    <div class="projects-main-page" v-if="projectsPage != null">
        <div class="container">
            <div class="section-title-main">
                <!-- <h1>{{projectsPage.projects_title}}</h1> -->
                <h1 v-if="lang == ''">НАШИ ПРОЕКТЫ</h1>
                <h1 v-if="lang == 'kz/'">БІЗДІҢ ЖОБАЛАР</h1>
                <h1 v-if="lang == 'en/'">Our Projects</h1>
            </div>
            <projectItems :projectItemsArr="projectItemsData" v-if="!isMobileChecker"></projectItems>
            <projectItemsMobile :projectItemsArr="projectItemsData" v-else></projectItemsMobile>
        </div>
        <formPage class="form-page-about"></formPage>
        <!-- <aboutUs_section></aboutUs_section>
        <history_section></history_section>
        <choose_section></choose_section>
        <mission_section></mission_section>
        <div class="corp-info-container">
            <promoNews></promoNews>
            <promoProjects></promoProjects>
        </div> -->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import projectItems from '@/components/projects/project-item.vue'
    import projectItemsMobile from '@/components/projects/project-item-mobile.vue'
    // import history_section from '@/components/about/history-section.vue'
    // import choose_section from '@/components/about/choose-bazis.vue'
    // import mission_section from '@/components/about/mission-section.vue'
    // import promoNews from '@/components/index-promo/promo-news.vue'
    // import promoProjects from '@/components/index-promo/promo-projects.vue'
	import formPage from '@/components/forms/form-page.vue';	

    export default {
        name: 'about--page',
        components: {
            projectItems,
            projectItemsMobile,
            // aboutUs_section,
            // history_section,
            // choose_section,
            // mission_section,
            // promoNews,
            // promoProjects,
            formPage,
        },
        data () {
            return {
                title: 'Наши проекты',
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            projectsPage: 'loadProjectsPage',
            projectItemsData: 'loadProjectsBuiltItems',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getProjectsPage');
            // store.dispatch('getIndexPageData');
            if (store.state.projectBuiltItems != null) {
                next(vm => {
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 300);
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getProjectBuiltObjects').then((response) => {
                    if (response) {
                        // console.log('asdasdasdasd')
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'about';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/projects/projects-page.scss';
    // @import '@/styles/components/about/respond/about-page-respond.scss';
</style>